import { CircularLoader, NoDataPage } from "@components/index";
import { getStatusClassName, formatDate } from "@utils/index";
import { tableColumns } from "./BookingListRenderData";
import "./index.scss";

const BookingListRender = ({
  bookings,
  loading,
  error,
  onViewBooking,
  onClearFilters,
}) => {
  // Show loading state
  if (loading) {
    return (
      <div className="booking-list-render__loading">
        <CircularLoader
          message="Loading Bookings Data ..."
          className="booking-list-render__loading-container"
        />
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="booking-list-render__no-data">
        <NoDataPage
          showRetryButton
          onButtonClick={onClearFilters}
          buttonText="Retry"
          message="Failed to load bookings data"
        />
      </div>
    );
  }

  // Show table if we have bookings
  if (bookings && bookings.length > 0) {
    return (
      <div className="booking-list-render">
        <div className="booking-list-render__table-container">
          <table className="bookings-table">
            <thead>
              <tr>
                {tableColumns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking, key) => (
                <tr key={key}>
                  <td>
                    <strong>{booking.pnr_number}</strong>
                  </td>
                  <td>{booking.train_name}</td>
                  <td>
                    {(() => {
                      const firstPassenger = booking.passengers?.[0];
                      return (
                        <div>
                          <div className="passenger_name">
                            {firstPassenger?.passenger_name ||
                              booking.customer_name}
                          </div>
                          <small className="bookings-table__meta">
                            {firstPassenger?.age || booking.age} yrs,{" "}
                            {firstPassenger?.gender || booking.gender}
                          </small>
                        </div>
                      );
                    })()}
                  </td>
                  <td>{booking.mobile_number}</td>
                  <td>{formatDate(booking.journey_date)}</td>
                  <td>
                    <span className={getStatusClassName(booking.ticket_status)}>
                      {booking.ticket_status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="bookings-table__action-btn"
                      onClick={() => onViewBooking(booking)}
                      title="View Details"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Show no data state
  return (
    <div className="booking-list-render__no-data">
      <NoDataPage
        showRetryButton
        onButtonClick={onClearFilters}
        buttonText="Reset Filters"
        message="No bookings found"
      />
    </div>
  );
};

export default BookingListRender;
